import { AccommodationActivity } from "@/lib/builder/models/activity.model";

export const createCheckInOutActivities = (activityData: AccommodationActivity): AccommodationActivity[] => {
    const checkInDate = (activityData as any).check_in_date || activityData.start_date || (activityData as any).from_date;
    const checkOutDate = (activityData as any).check_out_date || activityData.end_date || (activityData as any).to_date;

    const generatedId = 'TEMP-' + activityData.title + Date.now().toString();

    // Create check-in activity
    return [
        {
            address: activityData.address,
            check_in_note: activityData.check_in_note,
            check_in_time: activityData.check_in_time,
            check_out_time: activityData.check_out_time,
            cost: activityData.cost,
            description: activityData.description,
            documentation: activityData.documentation,
            price_tag: activityData.price_tag,
            link: activityData.link,
            media: activityData.media,
            refundable_rate: activityData.refundable_rate,
            include_price: activityData.include_price,
            type: 'accommodationIn',
            title: activityData.title,
            start_date: checkInDate,
            end_date: checkOutDate,
            id: generatedId + '-in',
            location: activityData.location,
            date: activityData.start_date
        },
        {
            address: activityData.address,
            check_in_time: null,
            check_out_time: activityData.check_out_time,
            cost: null,
            description: activityData.description,
            documentation: activityData.documentation,
            link: activityData.link,
            media: activityData.media,
            refundable_rate: activityData.refundable_rate,
            include_price: activityData.include_price,
            type: 'accommodationOut',
            title: activityData.title,
            start_date: checkOutDate,
            end_date: checkOutDate,
            check_in_note: "",
            price_tag: "",
            id: generatedId + '-out',
            location: activityData.location,
            date: activityData.end_date
        }
    ];
};